<template>
    <div class="px-7 py-6 box-border w-full mt-4 shadow-[0_10px_20px_0px_rgba(0,0,0,0.03)] rounded relative overflow-hidden">
        <div class="skeleton-loader w-1/3 h-8 rounded-3xl mt-2"></div>
        <div class="skeleton-loader w-full h-8 rounded-3xl mt-2"></div>
        <div class="skeleton-loader w-1/4 h-6 rounded-3xl mt-2"></div>
        <div class="skeleton-loader w-full h-6 rounded-3xl mt-4 mb-4"></div>
        <div class="skeleton-loader w-1/2 h-10 rounded-3xl mt-2" v-for="i in 4" :key="i"></div>
    </div>
</template>

<script setup>
</script>